import { WorkflowListProps } from "interfaces/workflows/WorkflowListProps";
import { WorkflowDto } from "models/workflows/WorkflowDto";
import { useEffect, useState } from "react";
import { ApiService } from "services/ApiService";

export const WorkflowsList: React.FC<WorkflowListProps> = ({ ownerId, onCreateNew, onSelect }) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [workflowList, setWorkflowList] = useState<WorkflowDto[]>([]);

    const handleDeleteWorkflow = async (workflowId: string) => {
        try {
            const response = await ApiService.deleteWorkflow(workflowId);

            console.log("response is " + response);
            if (response.success) {
                setWorkflowList((workflows) => {
                    return workflows.filter((c) => c.id !== workflowId);
                });
            }
        } catch {
            console.log("deleting here is failing");
        }
    };

    useEffect(() => {
        const fetchWorkflows = async () => {
            try {
                const response = await ApiService.getWorkflows(ownerId);

                if (response.success && response.data) {
                    setWorkflowList(response.data);
                }
            } catch (error) {
                console.error("Error fetching workflows:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchWorkflows();
    }, [ownerId]);

    if (isLoading) {
        return <p>Loading...</p>;
    }

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Workflows</h2>
            {workflowList.length > 0 ? (
                <ul className="divide-y divide-gray-300">
                    {workflowList.map((workflow) => (
                        <li
                            key={workflow.id}
                            onClick={() => onSelect(workflow.id)}
                            className="cursor-pointer p-4 hover:bg-gray-100 flex justify-between items-center border border-gray-200 rounded"
                        >
                            <span>{workflow.name.length > 0 ? workflow.name : workflow.id}</span>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteWorkflow(workflow.id);
                                }}
                                className="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-2 rounded"
                            >
                                Delete
                            </button>
                        </li>

                    ))}
                </ul>
            ) : (
                <p className="text-gray-600">No workflows found :/</p>
            )}
            <button
                onClick={onCreateNew}
                className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
                Create New Workflow
            </button>
        </div>
    );
};